import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";

// --- EXPANDED USER DETAILS SUB-COMPONENT ---
const ExpandedUserDetails = ({ mobile, onActionComplete }) => {
    const { callApi: searchUser } = useApi("/admin/cashin/search-user", "GET");
    const { callApi: getOdAccountApi } = useApi("/od/admin/account", "GET");
    const { callApi: enableOdApi } = useApi("/od/admin/enable", "POST");
    const { callApi: updateOdApi } = useApi("/od/admin/update", "PUT");
    const { callApi: disableOdApi } = useApi("/od/admin/disable", "POST");
    const { callApi: unblockOdApi } = useApi("/od/admin/unblock", "POST");

    const { callApi: uploadOdDocApi } = useApi("/od/admin/documents/upload", "POST");

    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);

    // OD States
    const [odSanctionedAmount, setOdSanctionedAmount] = useState("");
    const [odData, setOdData] = useState(null);
    const [odLoading, setOdLoading] = useState(false);
    const [odCreditLimit, setOdCreditLimit] = useState("");
    const [odPenalty, setOdPenalty] = useState("0.5");
    const [odPenaltyType, setOdPenaltyType] = useState("PERCENTAGE");
    const [odRemarks, setOdRemarks] = useState("");
    const [odActionLoading, setOdActionLoading] = useState(false);
    const [odConfirmAction, setOdConfirmAction] = useState(null);
    const [resultPopup, setResultPopup] = useState(null);

    const [docLabel, setDocLabel] = useState("");
    const [docFile, setDocFile] = useState(null);
    const [docUploading, setDocUploading] = useState(false);

    const mid = useSelector((state) => state.auth.employeeDetails?.username);

    const [odMpin, setOdMpin] = useState("");
    const [odOtpPopup, setOdOtpPopup] = useState({ open: false, pendingPayload: null, apiType: null, sentTo: [] });
    const [odOtpInput, setOdOtpInput] = useState("");
    const [odOtpError, setOdOtpError] = useState("");
    const [odOtpLoading, setOdOtpLoading] = useState(false);

    // const fetchOdData = async (uname) => {
    //     setOdLoading(true);
    //     const res = await getOdAccountApi(null, `?username=${uname}`);
    //     const isNotFound = !res || res?.message?.toLowerCase().includes("no od account");
    //     if (!isNotFound) {
    //         setOdData(res);
    //         if (res?.creditLimit) setOdCreditLimit(String(res.creditLimit));
    //         if (res?.penaltyAmount) setOdPenalty(String(res.penaltyAmount));
    //         if (res?.penaltyType) setOdPenaltyType(res.penaltyType);
    //     } else {
    //         setOdData({ notFound: true });
    //         setOdCreditLimit("");
    //         setOdPenalty("0.5");
    //         setOdPenaltyType("PERCENTAGE");
    //         setOdRemarks("");
    //     }
    //     setOdLoading(false);
    // };
    const fetchOdData = async (uname) => {
        setOdLoading(true);
        const res = await getOdAccountApi(null, `?username=${uname}`);
        const isNotFound = !res || res?.message?.toLowerCase().includes("no od account");
        if (!isNotFound) {
            setOdData(res);
            if (res?.sanctionedAmount !== undefined) setOdSanctionedAmount(String(res.sanctionedAmount)); // 👈 ADD THIS
            if (res?.creditLimit) setOdCreditLimit(String(res.creditLimit));
            if (res?.penaltyAmount) setOdPenalty(String(res.penaltyAmount));
            if (res?.penaltyType) setOdPenaltyType(res.penaltyType);
        } else {
            setOdData({ notFound: true });
            setOdSanctionedAmount(""); // 👈 ADD THIS
            setOdCreditLimit("");
            setOdPenalty("0.5");
            setOdPenaltyType("PERCENTAGE");
            setOdRemarks("");
        }
        setOdLoading(false);
    };

    const fetchUserDetails = async () => {
        try {
            setLoading(true);
            const res = await searchUser(null, `?keyword=${mobile}`);
            setUserData(res);
            if (res?.username) {
                await fetchOdData(res.username);
            }
        } catch (error) {
            console.error("Error fetching user:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (mobile) {
            fetchUserDetails();
        }
    }, [mobile]);

    // const executeOdAction = async () => {
    //     const action = odConfirmAction;
    //     setOdConfirmAction(null);
    //     setOdActionLoading(true);

    //     const uname = userData?.username;
    //     let res;

    //     try {
    //         if (action === "ENABLE") {
    //             res = await enableOdApi({
    //                 username: uname,
    //                 creditLimit: Number(odCreditLimit),
    //                 penaltyAmount: Number(odPenalty) || 0,
    //                 penaltyType: odPenaltyType,
    //                 remarks: odRemarks,
    //             });
    //         } else if (action === "UPDATE") {
    //             res = await updateOdApi({
    //                 username: uname,
    //                 creditLimit: Number(odCreditLimit),
    //                 penaltyAmount: Number(odPenalty) || 0,
    //                 penaltyType: odPenaltyType,
    //                 remarks: odRemarks,
    //             });
    //         } else if (action === "DISABLE") {
    const executeOdAction = async () => {
        const action = odConfirmAction;
        setOdConfirmAction(null);
        setOdActionLoading(true);

        const uname = userData?.username;
        let res;

        const odPayload = {
            username: uname,
            sanctionedAmount: Number(odSanctionedAmount) || 0,
            creditLimit: Number(odCreditLimit),
            penaltyAmount: Number(odPenalty) || 0,
            penaltyType: odPenaltyType,
            remarks: odRemarks,
            mpin: odMpin,
            mid,
        };

        try {
            if (action === "ENABLE") {
                res = await enableOdApi(odPayload);
            } else if (action === "UPDATE") {
                res = await updateOdApi(odPayload);
            } else if (action === "DISABLE") {
                res = await disableOdApi({ username: uname });
            } else if (action === "UNBLOCK") {
                res = await unblockOdApi({ username: uname });
            }

            setResultPopup({
                status: res?.success ? "SUCCESS" : "FAILED",
                message: res?.message || `${action} OD successfully processed.`,
            });

            if (res) {
                await fetchOdData(uname);
                if (onActionComplete) onActionComplete();
            }
        } catch (err) {
            const errData = err?.responseData || {};
            if (errData?.error_code === "OTP_REQUIRED" && errData?.action_params?.otpRequired === true) {
                setOdOtpPopup({
                    open: true,
                    pendingPayload: odPayload,
                    apiType: action,
                    sentTo: errData.action_params?.sentTo || [],
                });
                setOdActionLoading(false);
                return;
            }
            setResultPopup({
                status: "FAILED",
                message: err?.message || "Something went wrong",
            });
        } finally {
            setOdActionLoading(false);
        }
    };

    const handleOdOtpSubmit = async () => {
        if (odOtpInput.length !== 6) { setOdOtpError("Please enter a valid 6-digit OTP"); return; }
        setOdOtpLoading(true);
        setOdOtpError("");
        const uname = odOtpPopup.pendingPayload?.username;
        try {
            const payload = { ...odOtpPopup.pendingPayload, otp: odOtpInput.trim() };
            let res;
            if (odOtpPopup.apiType === "ENABLE") {
                res = await enableOdApi(payload);
            } else {
                res = await updateOdApi(payload);
            }
            setOdOtpPopup({ open: false, pendingPayload: null, apiType: null, sentTo: [] });
            setOdOtpInput("");
            setResultPopup({
                status: res?.success ? "SUCCESS" : "FAILED",
                message: res?.message || "OD action processed successfully.",
            });
            if (res) {
                await fetchOdData(uname);
                if (onActionComplete) onActionComplete();
            }
        } catch (err) {
            setOdOtpError(err?.message || "Invalid or expired OTP. Please try again.");
        } finally {
            setOdOtpLoading(false);
        }
    };

    const handleUploadDocument = async () => {
        if (!docLabel.trim()) { setResultPopup({ status: "FAILED", message: "Document label is required" }); return; }
        if (!docFile) { setResultPopup({ status: "FAILED", message: "Please select a file to upload" }); return; }

        setDocUploading(true);
        try {
            const formData = new FormData();
            formData.append("username", userData?.username);
            formData.append("docLabel", docLabel.trim());
            formData.append("uploadedBy", userData?.username); // or global username if available
            formData.append("file", docFile);

            const res = await uploadOdDocApi(formData);
            
            setResultPopup({ status: "SUCCESS", message: res?.message || "Document uploaded successfully" });
            setDocLabel("");
            setDocFile(null);
            
            const fileInput = document.getElementById("odAdminFileInput");
            if (fileInput) fileInput.value = "";
            
            await fetchOdData(userData?.username);
        } catch (err) {
            setResultPopup({ status: "FAILED", message: err?.response?.data?.message || err?.message || "Document upload failed" });
        } finally {
            setDocUploading(false);
        }
    };



    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center py-10">
                <div className="w-8 h-8 border-4 border-gray-200 border-t-[#123456] rounded-full animate-spin mb-3"></div>
                <p className="text-sm font-medium text-[#123456]">Loading detailed user profile...</p>
            </div>
        );
    }

    if (!userData) {
        return <div className="text-center py-8 text-sm text-red-500 font-medium">Failed to load user data.</div>;
    }

    return (
        <div className="bg-gray-50/80 p-6 shadow-inner relative">
           <div className="bg-white border rounded-xl shadow-sm p-5 mb-5 grid grid-cols-2 md:grid-cols-4 gap-6">
                {/* System Identifiers */}
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">Username</p>
                    <p className="text-sm font-medium text-gray-900">{userData.username || "—"}</p>
                </div>
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">System User ID</p>
                    <p className="text-sm font-medium text-gray-900 truncate" title={userData.userId}>
                        {userData.userId || "—"}
                    </p>
                </div>
                
                {/* Contact & KYC */}
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">Email</p>
                    <p className="text-sm font-medium text-gray-900 truncate" title={userData.email}>
                        {userData.email || "—"}
                    </p>
                </div>
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">Wallet Balance</p>
                    <p className="text-sm font-bold text-green-600">₹ {Number(userData.walletBalance || 0).toLocaleString("en-IN")}</p>
                </div>
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">PAN Card</p>
                    <p className="text-sm font-medium text-gray-900">{userData.pan || "—"}</p>
                </div>
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">Aadhaar</p>
                    <p className="text-sm font-medium text-gray-900">{userData.aadhar || "—"}</p>
                </div>

                {/* Shop Address (Spans 2 columns for better readability) */}
                <div className="col-span-2">
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">Full Address</p>
                    <p className="text-sm font-medium text-gray-900 truncate" title={`${userData.shopAddress}, ${userData.shopDistrict}, ${userData.shopState} - ${userData.shopPinCode}`}>
                        {userData.shopAddress ? `${userData.shopAddress}, ${userData.shopDistrict}, ${userData.shopState} - ${userData.shopPinCode}` : "—"}
                    </p>
                </div>

                {/* Banking Details */}
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">Account Holder</p>
                    <p className="text-sm font-medium text-gray-900 truncate" title={userData.accountHolderName}>
                        {userData.accountHolderName || "—"}
                    </p>
                </div>
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">Bank Name</p>
                    <p className="text-sm font-medium text-gray-900">{userData.bankName || "—"}</p>
                </div>
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">Account No.</p>
                    <p className="text-sm font-medium text-gray-900">{userData.accountNumber || "—"}</p>
                </div>
                <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-1">IFSC Code</p>
                    <p className="text-sm font-medium text-gray-900">{userData.ifscCode || "—"}</p>
                </div>

                {/* --- NEW HIERARCHY MINI TAB --- */}
                {userData.hierarchy && userData.hierarchy.length > 0 && (
                    <div className="col-span-2 md:col-span-4 mt-2 pt-5 border-t border-gray-200">
                        <p className="text-[11px] text-[#123456] font-bold uppercase tracking-wider mb-3">Hierarchy Chain</p>
                        <div className="flex flex-wrap items-center gap-2">
                            {userData.hierarchy.map((node, i) => (
                                <React.Fragment key={i}>
                                    <div className="bg-white border border-gray-300 rounded-lg p-2 min-w-[150px] shadow-sm hover:shadow-md transition-shadow">
                                        <p className="text-xs font-bold text-gray-800 truncate">
                                            {node.fullName} <span className="font-normal text-gray-500">({node.bpUserId})</span>
                                        </p>
                                        <p className="text-[10px] font-bold text-indigo-600 uppercase mt-0.5 tracking-wider">{node.role}</p>
                                        <p className="text-[10px] text-gray-500 font-mono mt-1">📱 {node.mobile}</p>
                                    </div>
                                    {i < userData.hierarchy.length - 1 && (
                                        <svg className="w-4 h-4 text-gray-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                                        </svg>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* OD Management Section */}
        {/* OD Management Section */}
           {/* OD Management Section */}
            <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-100 rounded-xl p-5">
                <div className="flex items-center justify-between mb-4">
                    <div>
                        <h3 className="text-base font-bold text-gray-800">Overdraft (OD) Management</h3>
                        <p className="text-xs text-gray-500 mt-0.5">Configure OD credit line for this merchant</p>
                    </div>
                    {odData && !odData.notFound && (
                        <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                            odData.status === "ACTIVE" ? "bg-green-100 text-green-700 border border-green-200"
                            : odData.status === "BLOCKED" ? "bg-amber-100 text-amber-700 border border-amber-200"
                            : "bg-red-100 text-red-700 border border-red-200"
                        }`}>{odData.message || odData.status}</span>
                    )}
                </div>

                {odLoading ? (
                    <div className="flex items-center gap-2 text-gray-500 text-sm py-3">
                        <div className="w-4 h-4 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
                        Loading OD data...
                    </div>
                ) : !odData || odData.notFound ? (
                    <>
                        <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 mb-4 text-sm text-amber-700 font-medium">
                            OD is not enabled for this user. Fill details below to enable.
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
                            <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">Sanction Limit (₹)</label>
                                <input type="number" placeholder="e.g. 100000" value={odSanctionedAmount} onChange={(e) => setOdSanctionedAmount(e.target.value)}
                                    className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm bg-white" />
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">Credit Limit (₹)</label>
                                <input type="number" placeholder="e.g. 50000" value={odCreditLimit} onChange={(e) => setOdCreditLimit(e.target.value)}
                                    className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm bg-white" />
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">Penalty {odPenaltyType === "PERCENTAGE" ? "(%)" : "(₹)"}</label>
                                <input type="number" placeholder="e.g. 2" value={odPenalty} onChange={(e) => setOdPenalty(e.target.value)}
                                    className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm bg-white" />
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">Penalty Type</label>
                                <select value={odPenaltyType} onChange={(e) => setOdPenaltyType(e.target.value)}
                                    className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm bg-white">
                                    <option value="FLAT">FLAT</option>
                                    <option value="PERCENTAGE">PERCENTAGE</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">Remarks</label>
                                <input type="text" placeholder="Enter remarks" value={odRemarks} onChange={(e) => setOdRemarks(e.target.value)}
                                    className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm bg-white" />
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">MPIN <span className="text-red-500">*</span></label>
                                <input type="password" maxLength={6} value={odMpin} onChange={(e) => setOdMpin(e.target.value.replace(/\D/g, ""))}
                                    placeholder="Enter MPIN"
                                    className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm bg-white tracking-widest text-center font-semibold" />
                            </div>
                            <div className="flex items-end">
                                <button
                                    onClick={() => {
                                        if (!odCreditLimit || Number(odCreditLimit) <= 0) { setResultPopup({ status: "FAILED", message: "Enter valid credit limit" }); return; }
                                        if (!odRemarks?.trim()) { setResultPopup({ status: "FAILED", message: "Remarks required" }); return; }
                                        setOdConfirmAction("ENABLE");
                                    }}
                                    disabled={odActionLoading}
                                    className="w-full h-[42px] bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 disabled:opacity-50 text-white font-semibold rounded-xl shadow-sm transition-all text-sm flex items-center justify-center gap-2">
                                    {odActionLoading ? "Processing..." : "Enable OD"}
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
                            <div className="bg-white rounded-xl p-3 border text-center shadow-sm">
                                <p className="text-xs text-gray-400 font-medium">Sanctioned Limit</p>
                                <p className="text-[15px] font-bold text-gray-800 mt-0.5">₹ {Number(odData.sanctionedAmount || 0).toLocaleString("en-IN")}</p>
                            </div>
                            <div className="bg-white rounded-xl p-3 border text-center shadow-sm">
                                <p className="text-xs text-gray-400 font-medium">Usable Limit</p>
                                <p className="text-[15px] font-bold text-gray-800 mt-0.5">₹ {Number(odData.creditLimit || 0).toLocaleString("en-IN")}</p>
                            </div>
                            <div className="bg-white rounded-xl p-3 border text-center shadow-sm">
                                <p className="text-xs text-gray-400 font-medium">Utilized</p>
                                <p className="text-[15px] font-bold text-red-600 mt-0.5">₹ {Number(odData.utilizedAmount || 0).toLocaleString("en-IN")}</p>
                            </div>
                            <div className="bg-white rounded-xl p-3 border text-center shadow-sm">
                                <p className="text-xs text-gray-400 font-medium">Available</p>
                                <p className="text-[15px] font-bold text-green-600 mt-0.5">₹ {Number(odData.availableLimit || 0).toLocaleString("en-IN")}</p>
                            </div>
                        </div>

                        {odData?.status === "DISABLED" && (
                            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm mb-5">
                                <strong>Note:</strong> OD is disabled. Update limits to re-enable, or upload required documents.
                            </div>
                        )}

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                            {/* Update Forms */}
                            <div className="space-y-4">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Sanctioned (₹)</label>
                                        <input type="number" value={odSanctionedAmount} onChange={(e) => setOdSanctionedAmount(e.target.value)}
                                            className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none bg-white" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Usable Limit (₹)</label>
                                        <input type="number" value={odCreditLimit} onChange={(e) => setOdCreditLimit(e.target.value)}
                                            className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none bg-white" />
                                    </div>
                                </div>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Penalty {odPenaltyType === "PERCENTAGE" ? "(%)" : "(₹)"}</label>
                                        <input type="number" value={odPenalty} onChange={(e) => setOdPenalty(e.target.value)}
                                            className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none bg-white" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Penalty Type</label>
                                        <select value={odPenaltyType} onChange={(e) => setOdPenaltyType(e.target.value)}
                                            className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none bg-white">
                                            <option value="FLAT">FLAT</option>
                                            <option value="PERCENTAGE">PERCENTAGE</option>
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-xs font-medium text-gray-600 mb-1">Remarks</label>
                                    <input type="text" placeholder="Enter remarks" value={odRemarks} onChange={(e) => setOdRemarks(e.target.value)}
                                        className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none bg-white" />
                                </div>
                                <div>
                                    <label className="block text-xs font-medium text-gray-600 mb-1">MPIN <span className="text-red-500">*</span></label>
                                    <input type="password" maxLength={6} value={odMpin} onChange={(e) => setOdMpin(e.target.value.replace(/\D/g, ""))}
                                        placeholder="Enter MPIN"
                                        className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none bg-white tracking-widest text-center font-semibold" />
                                </div>

                                {/* <div className="flex gap-2 pt-2">
                                    <button
                                        onClick={() => {
                                            if (!odCreditLimit || Number(odCreditLimit) <= 0) { setResultPopup({ status: "FAILED", message: "Enter valid credit limit" }); return; }
                                            if (!odRemarks?.trim()) { setResultPopup({ status: "FAILED", message: "Remarks required" }); return; }
                                            setOdConfirmAction("UPDATE");
                                        }}
                                        disabled={odActionLoading}
                                        className="flex-1 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 disabled:opacity-50 text-white font-semibold py-2 rounded-xl shadow-sm transition-all text-sm">
                                        {odData?.status === "DISABLED" ? "Re-Enable OD" : "Update OD"}
                                    </button>
                                    {odData.status === "BLOCKED" && (
                                        <button onClick={() => setOdConfirmAction("UNBLOCK")} disabled={odActionLoading}
                                            className="px-4 bg-blue-500 hover:bg-blue-600 disabled:opacity-50 text-white font-semibold py-2 rounded-xl shadow-sm transition-all text-sm">
                                            Unblock
                                        </button>
                                    )}
                                    {odData.status !== "DISABLED" && (
                                        <button onClick={() => setOdConfirmAction("DISABLE")} disabled={odActionLoading}
                                            className="px-4 bg-red-500 hover:bg-red-600 disabled:opacity-50 text-white font-semibold py-2 rounded-xl shadow-sm transition-all text-sm">
                                            Disable OD
                                        </button>
                                    )}
                                </div> */}
                                <div className="flex flex-wrap gap-2 pt-2">
                                    {!odData || odData.notFound || odData.status === "DISABLED" ? (
                                        <button 
                                            onClick={() => {
                                                if (!odCreditLimit || Number(odCreditLimit) <= 0) { setResultPopup({ status: "FAILED", message: "Enter valid credit limit" }); return; }
                                                if (!odRemarks?.trim()) { setResultPopup({ status: "FAILED", message: "Remarks required" }); return; }
                                                
                                                // 🔥 CHANGED HERE: Always trigger "ENABLE" action for both new and disabled accounts
                                                setOdConfirmAction("ENABLE"); 
                                            }}
                                            disabled={odActionLoading}
                                            className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 disabled:opacity-50 text-white font-semibold py-2 rounded-xl text-sm transition-all shadow-sm flex items-center justify-center gap-2"
                                        >
                                            {odActionLoading ? "Processing..." : (
                                                <>
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"></path>
                                                    </svg>
                                                    {odData?.status === "DISABLED" ? "Re-Enable OD Account" : "Create & Enable OD Account"}
                                                </>
                                            )}
                                        </button>
                                    ) : (
                                        <>
                                            <button onClick={() => {
                                                    if (!odCreditLimit || Number(odCreditLimit) <= 0) { setResultPopup({ status: "FAILED", message: "Enter valid credit limit" }); return; }
                                                    if (!odRemarks?.trim()) { setResultPopup({ status: "FAILED", message: "Remarks required" }); return; }
                                                    setOdConfirmAction("UPDATE");
                                                }} disabled={odActionLoading}
                                                className="flex-1 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold py-2 px-3 rounded-xl text-sm transition-all shadow-sm">
                                                Update OD
                                            </button>

                                            {odData.status === "BLOCKED" && (
                                                <button onClick={() => setOdConfirmAction("UNBLOCK")} disabled={odActionLoading}
                                                    className="px-4 bg-blue-500 hover:bg-blue-600 disabled:opacity-50 text-white font-semibold py-2 rounded-xl shadow-sm transition-all text-sm">
                                                    Unblock
                                                </button>
                                            )}

                                            <button onClick={() => setOdConfirmAction("DISABLE")} disabled={odActionLoading}
                                                className="px-4 bg-red-500 hover:bg-red-600 disabled:opacity-50 text-white font-semibold py-2 rounded-xl shadow-sm transition-all text-sm">
                                                Disable OD
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Documents Viewer */}
                            <div className="border border-amber-200 bg-amber-100/30 rounded-xl p-4 flex flex-col h-full">
                                <h4 className="text-sm font-semibold text-gray-700 mb-3 px-1">OD Documents</h4>
                                <div className="flex-1 space-y-2 overflow-y-auto max-h-[150px] pr-1 mb-4 scrollbar-thin">
                                    {(odData.documents && odData.documents.length > 0) ? (
                                        odData.documents.map((doc, idx) => (
                                            <div key={idx} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-2.5 shadow-sm">
                                                <div className="flex flex-col min-w-0 pr-2">
                                                    <span className="text-sm text-gray-800 font-semibold truncate">{doc.label}</span>
                                                    <span className="text-[11px] text-gray-500 truncate mt-0.5">By {doc.uploadedBy || "System"} • {new Date(doc.uploadedAt).toLocaleDateString("en-IN")}</span>
                                                </div>
                                                <a href={doc.url} target="_blank" rel="noreferrer" 
                                                    className="text-xs bg-indigo-50 text-indigo-700 px-3 py-1.5 rounded-md font-medium hover:bg-indigo-100 transition-colors whitespace-nowrap shrink-0">
                                                    View
                                                </a>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-xs text-gray-500 text-center py-4 bg-white/50 rounded-lg border border-dashed border-gray-300">
                                            No documents uploaded yet.
                                        </div>
                                    )}
                                </div>
                                <div className="bg-white p-3 rounded-xl border shadow-sm mt-auto">
                                    <p className="text-xs font-semibold text-gray-600 mb-2">Upload New Document</p>
                                    <div className="flex flex-col gap-2">
                                        <input type="text" placeholder="Label (e.g. Agreement, Cheque)" value={docLabel} onChange={(e) => setDocLabel(e.target.value)}
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none" />
                                        <div className="flex items-center gap-2">
                                            <input 
                                                id={`odFileInput-${userData?.username}`} 
                                                type="file" 
                                                onChange={(e) => setDocFile(e.target.files[0])}
                                                className="flex-1 text-xs text-gray-600 file:mr-2 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:font-semibold file:bg-amber-50 file:text-amber-700 hover:file:bg-amber-100 cursor-pointer" 
                                            />
                                            <button onClick={handleUploadDocument} disabled={docUploading || !docFile || !docLabel.trim()}
                                                className="bg-amber-600 hover:bg-amber-700 disabled:opacity-50 text-white text-xs font-semibold px-4 py-2 rounded-lg transition-colors whitespace-nowrap shrink-0">
                                                {docUploading ? "Uploading..." : "Upload"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/* OD CONFIRM MODAL (Scoped to expanded row) */}
            {odConfirmAction && (
                <div className="absolute inset-0 bg-black/40 rounded-xl flex items-center justify-center z-20 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-2xl">
                        <h2 className="text-lg font-bold mb-1 text-gray-800">
                            Confirm {odConfirmAction === "ENABLE" ? "Enable OD" : odConfirmAction === "UPDATE" ? "Update OD" : odConfirmAction === "DISABLE" ? "Disable OD" : "Unblock OD"}
                        </h2>
                        <p className="text-sm text-gray-500 mb-5 text-wrap">
                            {odConfirmAction === "ENABLE" && <>Enable OD for <b>{userData?.username}</b> with credit limit <b>₹{Number(odCreditLimit).toLocaleString("en-IN")}</b>?</>}
                            {odConfirmAction === "UPDATE" && <>Update OD for <b>{userData?.username}</b> — credit limit <b>₹{Number(odCreditLimit).toLocaleString("en-IN")}</b>?</>}
                            {odConfirmAction === "DISABLE" && <>Disable OD for <b>{userData?.username}</b>? This fails if there is any outstanding balance.</>}
                            {odConfirmAction === "UNBLOCK" && <>Manually unblock OD for <b>{userData?.username}</b>?</>}
                        </p>
                        <div className="flex justify-end gap-3">
                            <button onClick={() => setOdConfirmAction(null)} className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 font-medium text-sm hover:bg-gray-200">Cancel</button>
                            <button onClick={executeOdAction} disabled={odActionLoading} className={`px-4 py-2 rounded-lg text-white font-medium text-sm transition-colors ${odConfirmAction === "DISABLE" ? "bg-red-500 hover:bg-red-600" : "bg-amber-500 hover:bg-amber-600"}`}>
                                {odActionLoading ? "Processing..." : "Confirm"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* OD OTP MODAL */}
            {odOtpPopup.open && (
                <div className="absolute inset-0 bg-black/50 rounded-xl flex items-center justify-center z-20 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-md overflow-hidden">
                        <div className="bg-gradient-to-r from-[#0A2A4F] to-[#1a4a8f] px-6 py-4 flex items-center justify-between">
                            <h3 className="text-white font-bold text-base">OTP Verification</h3>
                            <button
                                onClick={() => { setOdOtpPopup({ open: false, pendingPayload: null, apiType: null, sentTo: [] }); setOdOtpInput(""); setOdOtpError(""); }}
                                disabled={odOtpLoading}
                                className="text-white/70 hover:text-white text-xl leading-none disabled:opacity-40"
                            >✕</button>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div>
                                <p className="text-sm text-gray-600 mb-2">OTP has been sent to:</p>
                                <div className="flex flex-wrap gap-2">
                                    {odOtpPopup.sentTo.map((num, i) => (
                                        <span key={i} className="px-3 py-1 bg-amber-50 border border-amber-200 rounded-full text-sm font-semibold text-amber-700 tracking-wider">{num}</span>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Enter 6-digit OTP</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={6}
                                    value={odOtpInput}
                                    onChange={e => { setOdOtpInput(e.target.value.replace(/\D/g, "")); setOdOtpError(""); }}
                                    placeholder="_ _ _ _ _ _"
                                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-100 outline-none text-gray-800 font-bold tracking-[0.6em] text-center text-xl"
                                />
                                <p className="text-right text-xs mt-1" style={{ color: odOtpInput.length === 6 ? "#16a34a" : "#9ca3af" }}>
                                    {odOtpInput.length} / 6
                                </p>
                            </div>
                            {odOtpError && (
                                <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-sm text-red-600 font-medium">{odOtpError}</div>
                            )}
                            <button
                                onClick={handleOdOtpSubmit}
                                disabled={odOtpLoading || odOtpInput.length !== 6}
                                className="w-full py-3 rounded-xl bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-semibold text-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {odOtpLoading ? (
                                    <span className="flex items-center justify-center gap-2">
                                        <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/></svg>
                                        Verifying...
                                    </span>
                                ) : "Approve"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* RESULT POPUP */}
            {resultPopup && (
                <div className="absolute inset-0 bg-black/40 rounded-xl flex items-center justify-center z-30 backdrop-blur-sm">
                    <div className="bg-white w-[90%] max-w-sm rounded-2xl shadow-2xl p-6 text-center">
                        <div className={`w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4 ${resultPopup.status === "SUCCESS" ? "bg-green-100 text-green-600" : "bg-red-100 text-red-600"}`}>
                            <span className="text-2xl font-bold">{resultPopup.status === "SUCCESS" ? "✓" : "✕"}</span>
                        </div>
                        <h2 className={`text-xl font-bold mb-2 ${resultPopup.status === "SUCCESS" ? "text-green-600" : "text-red-600"}`}>{resultPopup.status}</h2>
                        <p className="text-gray-600 text-sm mb-5">{resultPopup.message}</p>
                        <button onClick={() => setResultPopup(null)} className="px-6 py-2 bg-[#123456] hover:bg-[#1a4b7c] text-white rounded-lg font-semibold text-sm transition-colors w-full">
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
        
// --- MAIN COMPONENT ---
const OdAdminHistory = () => {
    const { callApi: getOdAllApi } = useApi("/od/admin/all", "GET");
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    
    // State to track which row is currently expanded
    const [expandedRowBpId, setExpandedRowBpId] = useState(null);

    const fetchAccounts = async () => {
        setLoading(true);
        const res = await getOdAllApi(null);
        setAccounts(res?.accounts || []);
        setLoading(false);
    };

    useEffect(() => {
        fetchAccounts();
    }, []);

    const toggleRow = (bpId) => {
        if (expandedRowBpId === bpId) {
            setExpandedRowBpId(null);
        } else {
            setExpandedRowBpId(bpId);
        }
    };

    const downloadExcel = async () => {
        setDownloadLoading(true);
        let data = accounts;

        if (!data.length) {
            const res = await getOdAllApi(null);
            data = res?.accounts || [];
        }

        const rows = data.map((item, i) => ({
            "S.No":                i + 1,
            "User ID":             item.userId,
            "BP ID":               item.bpId,
            "Full Name":           item.fullName,
            "Mobile":              item.mobile,
            "Shop Name":           item.shopName,
            "Role":                item.role,
            "Status":              item.status,
            "OD Enabled":          item.isOdEnabled ? "Yes" : "No",
            "Credit Limit (₹)":    item.creditLimit,
            "Utilized Amount (₹)": item.utilizedAmount,
            "Available Limit (₹)": item.availableLimit,
            "Penalty Amount":      item.penaltyAmount,
            "Penalty Type":        item.penaltyType,
            "EOD Failure Attempts":item.eodFailureAttempts ?? 0,
            "Last Draw Date":      item.lastDrawDate || "",
            "Remarks":             item.remarks || "",
        }));

        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "OD Accounts");

        const today = new Date().toISOString().slice(0, 10);
        XLSX.writeFile(wb, `OD_Accounts_${today}.xlsx`);
        setDownloadLoading(false);
    };

    const statusConfig = {
        ACTIVE:   { cls: "bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20" },
        BLOCKED:  { cls: "bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-600/20" },
        DISABLED: { cls: "bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20" },
    };

    const roleColor = {
        MERCHANT:    "bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-600/20",
        DISTRIBUTOR: "bg-purple-50 text-purple-700 ring-1 ring-inset ring-purple-600/20",
        RETAILER:    "bg-teal-50 text-teal-700 ring-1 ring-inset ring-teal-600/20",
    };

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 mt-6 overflow-hidden">
            {/* Header Section */}
            <div className="px-6 py-5 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-white">
                <div>
                    <h2 className="text-xl font-bold text-[#123456]">All OD Accounts</h2>
                    <p className="text-sm text-gray-500 mt-1">
                        {accounts.length > 0 
                            ? `Showing ${accounts.length} registered overdraft record${accounts.length !== 1 ? "s" : ""}`
                            : "Manage your overdraft accounts"}
                    </p>
                </div>
                
                <div className="flex items-center gap-3">
                    <button
                        onClick={downloadExcel}
                        disabled={downloadLoading}
                        className="flex items-center gap-2 bg-[#123456] hover:bg-[#1a4b7c] disabled:opacity-70 text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-colors shadow-sm"
                    >
                        {downloadLoading ? "Exporting..." : "Export to Excel"}
                    </button>
                    <button
                        onClick={fetchAccounts}
                        disabled={loading}
                        className="flex items-center gap-2 bg-white hover:bg-gray-50 text-[#123456] border border-gray-300 disabled:opacity-70 text-sm font-semibold px-4 py-2.5 rounded-lg transition-colors shadow-sm"
                    >
                        <span className={loading ? "animate-spin inline-block" : ""}>⟳</span>
                        {loading ? "Refreshing..." : "Refresh"}
                    </button>
                </div>
            </div>

            {/* Content Area */}
            {loading ? (
                <div className="flex flex-col items-center justify-center py-20">
                    <div className="w-10 h-10 border-4 border-gray-200 border-t-[#123456] rounded-full animate-spin mb-4"></div>
                    <p className="text-[#123456] font-medium text-sm">Loading accounts...</p>
                </div>
            ) : accounts.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-20 text-center px-4">
                    <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4">
                        <span className="text-3xl">📭</span>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">No Accounts Found</h3>
                    <p className="text-sm text-gray-500 mt-1">There are currently no active overdraft accounts to display.</p>
                </div>
            ) : (
                <div className="overflow-x-auto border-t border-gray-300">
                    <div className="max-h-[75vh] overflow-y-auto">
                        <table className="min-w-full text-left text-sm whitespace-nowrap">
                            <thead className="sticky top-0 z-10 bg-gray-50 border-b border-gray-200 shadow-sm">
                                <tr>
                                    <th className="px-6 py-4 font-semibold text-gray-700 w-12 text-center">#</th>
        
                                    <th className="px-6 py-4 font-semibold text-gray-700">User Details</th>
                                    <th className="px-6 py-4 font-semibold text-gray-700">Role & Status</th>
                                    <th className="px-6 py-4 font-semibold text-gray-700">Credit Limit</th>
                                    <th className="px-6 py-4 font-semibold text-gray-700">Utilization</th>
                                    <th className="px-6 py-4 font-semibold text-gray-700">Penalty</th>
                                    <th className="px-6 py-4 font-semibold text-gray-700">Draw & Fails</th>
                                    <th className="px-6 py-4 font-semibold text-gray-700">Remarks</th>
                                    <th className="px-6 py-4 font-semibold text-gray-700 text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-300">
    {accounts.map((item, i) => {
        const sc = statusConfig[item.status] || { cls: "bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10" };
        const rc = roleColor[item.role] || "bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10";
        
        const utilPct = item.creditLimit > 0
            ? Math.min(100, Math.round((item.utilizedAmount / item.creditLimit) * 100))
            : 0;
        const barColor = utilPct > 80 ? "bg-red-500" : utilPct > 50 ? "bg-amber-400" : "bg-[#123456]";
        
        const isExpanded = expandedRowBpId === item.bpId;

        return (
            <React.Fragment key={i}>
                <tr className={`transition-colors ${isExpanded ? "bg-gray-50/50" : "hover:bg-gray-50/50 bg-white"}`}>
                    
                    {/* 🔥 FIX 3: Changed py-2 to py-4 so it matches all other cells perfectly */}
                    <td className="px-6 py-4 align-top text-center font-medium text-gray-500">
                        {i + 1}
                    </td>

                    {/* User Details */}
                    <td className="px-6 py-4 align-top">
                        <div className="font-semibold text-[#123456]">{item.bpId}</div>
                        <div className="text-gray-900 mt-0.5">{item.shopName || "—"}</div>
                        <div className="text-gray-500 text-xs mt-1">{item.mobile || "—"}</div>
                    </td>

                                                {/* Role & Status */}
                                                <td className="px-6 py-4 align-top">
                                                    <div className="flex flex-col items-start gap-2">
                                                        <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium uppercase ${rc}`}>
                                                            {item.role}
                                                        </span>
                                                        <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${sc.cls}`}>
                                                            {item.status}
                                                        </span>
                                                    </div>
                                                </td>

                                                {/* Credit Limit */}
                                                <td className="px-6 py-4 align-top">
                                                    <div className="font-semibold text-gray-900">
                                                        ₹{Number(item.creditLimit).toLocaleString("en-IN")}
                                                    </div>
                                                    <div className="text-green-600 text-xs font-medium mt-1">
                                                        ₹{Number(item.availableLimit).toLocaleString("en-IN")} Avail.
                                                    </div>
                                                </td>

                                                {/* Utilization */}
                                                <td className="px-6 py-4 align-top min-w-[180px]">
                                                    <div className="flex justify-between text-xs mb-1">
                                                        <span className="font-semibold text-gray-900">
                                                            ₹{Number(item.utilizedAmount).toLocaleString("en-IN")}
                                                        </span>
                                                        <span className="text-gray-500 font-medium">{utilPct}%</span>
                                                    </div>
                                                    <div className="w-full bg-gray-100 rounded-full h-1.5 overflow-hidden">
                                                        <div className={`h-1.5 rounded-full ${barColor}`} style={{ width: `${utilPct}%` }}></div>
                                                    </div>
                                                </td>

                                                {/* Penalty */}
                                                <td className="px-6 py-4 align-top">
                                                    <div className="font-semibold text-gray-900">
                                                        {item.penaltyType === "PERCENTAGE"
                                                            ? `${item.penaltyAmount}%`
                                                            : `₹${Number(item.penaltyAmount).toLocaleString("en-IN")}`}
                                                    </div>
                                                    <div className="text-gray-500 text-xs mt-1 uppercase tracking-wider">
                                                        {item.penaltyType}
                                                    </div>
                                                </td>

                                                {/* Last Draw & EOD Fails */}
                                                <td className="px-6 py-4 align-top">
                                                    <div className="text-gray-900 text-sm">{item.lastDrawDate || "—"}</div>
                                                    <div className="mt-2 flex items-center gap-2">
                                                        <span className="text-xs text-gray-500">EOD Fails:</span>
                                                        <span className={`inline-flex items-center justify-center px-2 py-0.5 rounded text-xs font-bold ${
                                                            item.eodFailureAttempts > 0 ? "bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20" : "bg-gray-100 text-gray-600"
                                                        }`}>
                                                            {item.eodFailureAttempts ?? 0}
                                                        </span>
                                                    </div>
                                                </td>

                                                {/* Remarks */}
                                                <td className="px-6 py-4 align-top whitespace-normal min-w-[150px]">
                                                    {item.remarks ? (
                                                        <span className="text-gray-600 text-sm leading-relaxed">{item.remarks}</span>
                                                    ) : (
                                                        <span className="text-gray-400 italic text-sm">No remarks</span>
                                                    )}
                                                </td>

                                                {/* Actions Toggle */}
                                                <td className="px-6 py-4 align-top text-center">
                                                    <button 
                                                        onClick={() => toggleRow(item.bpId)}
                                                        className={`p-2 rounded-full transition-all duration-200 ${isExpanded ? "bg-[#123456] text-white" : "bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-800"}`}
                                                    >
                                                        <svg className={`w-4 h-4 transform transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                                        </svg>
                                                    </button>
                                                </td>
                                            </tr>

                                            {/* EXPANDED ROW DATA */}
                                            {/* {isExpanded && (
                                                <tr>
                                                    <td colSpan={8} className="p-0 border-b-2 border-[#123456]/20">
                                                        <ExpandedUserDetails mobile={item.mobile} onActionComplete={fetchAccounts} />
                                                    </td>
                                                </tr>
                                            )} */}
                                            {isExpanded && (
                    <tr>
                        {/* 🔥 FIX 4: Changed colSpan from 8 to 9 */}
                        <td colSpan={9} className="p-0 border-b-2 border-[#123456]/20">
                            <ExpandedUserDetails mobile={item.mobile} onActionComplete={fetchAccounts} />
                        </td>
                    </tr>
                )}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OdAdminHistory;